export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/74cc88c7571ddfe8037db442e45677ad.svg";